import { render, staticRenderFns } from "./ResponseTemplate.vue?vue&type=template&id=0fc80144&scoped=true"
import script from "./ResponseTemplate.vue?vue&type=script&lang=js"
export * from "./ResponseTemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc80144",
  null
  
)

export default component.exports